export default {
  items: [
      {
        name: 'Dashboard',
        icon: 'icon-speedometer',
        url: '/dashboard'
      },
    {
      name: 'Profile',
      icon: 'icon-user',
      url: '/user/profile'
    },
      {
        name: 'Cadastro',
        icon: 'fa fa-bars',
        permission: 'Administrator',
        children: [

          {
            name: 'Centro de Custo',
            icon: 'fa fa-home',
            url: '/centrocusto',
            permission: 'Administrator'
          },
          {
            name: 'Grupos Perguntas',
            icon: 'icon-list',
            url: '/perguntagrupo',
            permission: 'Administrator'
          },
          {
            name: 'Perguntas',
            icon: 'icon-speech',
            url: '/pergunta',
            permission: 'Administrator'
          },
          {
            name: 'Formulas',
            icon: 'icon-chemistry',
            url: '/formula',
            permission: 'Administrator'
          },
          {
            name: 'Indicador',
            icon: 'icon-speedometer',
            url: '/indicador',
            permission: 'Administrator'
          },
          {
            name: 'Usuarios',
            icon: 'fa fa-user',
            url: '/user',
            permission: 'Administrator'
          },
          {
            name: 'Grupos',
            icon: 'icon-people',
            url: '/role',
            permission: 'Administrator'
          }
        ]
      },
      {
        name: 'Seeder',
        icon: 'icon-note',
        permission: 'Seeder|Administrator',
        children: [
          {
            name: 'Home',
            icon: 'icon-note',
            url: '/seeder',
            permission:'Seeder|Administrator'
          }
        ]
      },
    {
      name: 'Configuração',
      icon: 'fa fa-cog',
      permission: 'Administrator',
      children: [
        {
          name: 'Árvore',
          icon: 'fa fa-tree',
          url: '/arvore',
          permission: 'Administrator'
        },
        {
          name: 'Competência',
          icon: 'fa fa-cog',
          url: '/competencia',
          permission: 'Administrator'
        },
        {
          name: 'Período',
          icon: 'fa fa-calendar',
          url: '/periodo',
          permission: 'Administrator'
        },
        {
          name: 'Seeder Manager',
          icon: 'fa fa-users',
          url: '/seeder/manager',
          permission: 'Administrator'
        }
      ]
    },
      {
        name: 'Sair',
        icon: 'icon-power',
        url: '/logout'
      }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js